import React from "react";
import Link from "./Link";
import {useMenuItems} from "/src/_hooks/useMenuItems";
import styled from "styled-components";

const Nav = styled.nav`
  .navbar-nav {
    --bs-nav-link-font-size: 24px;
    --bs-nav-link-font-weight: 400;
    --bs-nav-link-hover-color: var(--bs-lime-green);
    --bs-nav-link-color: var(--bs-white);
    --bs-navbar-active-color: var(--bs-forest-green);
    @media (min-width: 640px) {
      --bs-nav-link-font-size: 36px;
    }
    svg {
      @media (max-width: 992px) {
        color: var(--bs-nav-link-color);
      }
    }
  }
  .nav-link.active span{
    z-index: 1;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: -6px;
      bottom: -6px;
      left: -6px;
      right: -6px;
      background-color: var(--bs-lime-green);
      transform: rotate(-1deg);
      z-index: -1;
    }
  }
`

const MenuFooter = ({location}) => {
  const menuItems = useMenuItems(location);

  return menuItems?.length > 0 ? (
    <Nav className="z-0">
      <ul className="navbar-nav mt-n12">
        {menuItems.map((menuItem, index) => (
            <li className={`nav-item py-12 border-bottom border-linen position-relative pe-30 pe-md-0 ${menuItem.cssClasses.join(' ')}`} key={menuItem.id + index}>
              <Link className="nav-link lh-1 font-family-heading text-uppercase d-flex" to={menuItem.path} target={menuItem.target}>
                <span className="d-inline-block">
                  {menuItem.label}
                  <svg
                    className="flex-shrink-0 ms-8 d-none d-lg-inline-block"
                    width="24" height="24">
                    <use xlinkHref="#icon-arrow-alt-r"/>
                  </svg>
                </span>
                <svg className="position-absolute end-0 top-0 mt-12 d-lg-none"
                  width="24" height="24">
                  <use xlinkHref="#icon-arrow-alt-r"/>
                </svg>
              </Link>
            </li>
          )
        )}
      </ul>
    </Nav>
  ) : null;
}

export default MenuFooter
